export const SET_CURRENT_MODAL = 'SET_CURRENT_MODAL'
export const SET_MODAL_DATA = 'SET_MODAL_DATA'
